module.exports = __webpack_public_path__ + "static/media/hdi-plus.c5bb5bc6.svg";